/** @format */
import { css } from 'styled-components';

import { BlockquoteProps } from './index';

/**
 * Base styles for the blockquote component
 *
 * @param {BlockquoteProps} props The blockquote properties object
 * */
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Legacy code: do not use as an example.
const baseStyles = (props: Omit<BlockquoteProps, 'quote'>) => {
    /* eslint-disable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
    return css`
        padding: 2.4rem 0 2.4rem 2.4rem;
        border-left: 2px solid var(--colors-border-interactive);
        margin-left: 0;
        font-weight: 200;
        font-size: 2.4rem;
        line-height: 3rem;
        color: var(--colors-text-secondary);
    `;
    /* eslint-enable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
};

/**
 * The blockquote component styles
 *
 * @param {BlockquoteProps} props The blockquote properties object
 * */
export const styles = (props: Omit<BlockquoteProps, 'quote'>) => css`
    ${baseStyles(props)}
`;
